import { render, staticRenderFns } from "./Wellbeing.vue?vue&type=template&id=2369fbb0&scoped=true&"
import script from "./Wellbeing.vue?vue&type=script&lang=js&"
export * from "./Wellbeing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369fbb0",
  null
  
)

export default component.exports